<style lang="stylus" scoped>
    .btn-add
        color #009ee7
        border 1px solid transparent
        background-color transparent
        font-size 14px
        &:hover
            background-color #009ee7
            color #ffffff

    .invite-list
        padding 15px 0
        border-bottom 1px solid #e3e3e3
        display flex
        .invite-name
            flex .2
        .invite-account
            flex .6
        .test-times
            flex .2

    .enter-group
        line-height 54px
        .btn
            border-radius 2px
            padding 4px 15px
            font-size 14px
            &.btn-danger
                background-color #ff7674
                border-color #ff7674
    .bg-white
        background-color: #fff !important
        &:hover
            background-color: #f2f5f6 !important

    .bg-pink
        color #fc5050 !important
        border 1px solid #fc5050 !important
        background-color: transparent !important
        &:hover
            background-color: #f2f5f6 !important
    .primary-text-color
        color #009ee7 !important
        border 1px solid #e0e6ed !important
    .ext-header
        border-top-left-radius 4px
        border-top-right-radius 4px
        position relative
        div
          padding 25px 30px 30px
          font-size 18px
    .flex-content
        display flex
        padding 0 15px
    .fl4
        flex 0.4
    .fl6
        flex 0.6
        border-left 1px dashed #e3e3e3
        padding-left 30px
    .ext-sub-title
        font-size 16px
    .pb10
        padding-bottom 10px
    .mt20
        margin-top 20px
    .active
        background-color #009ee7
        color #fff
    .pointer
        cursor pointer
    .account-pay
        border 1px solid #e3e3e3
        border-top-left-radius 4px
        border-top-right-radius 4px
    .weixin-pay
        border 1px solid #e3e3e3
    .ali-pay
        border-left 1px solid #e3e3e3
        border-right 1px solid #e3e3e3
        border-bottom 1px solid #e3e3e3
        border-bottom-left-radius 4px
        border-bottom-right-radius 4px
    .fl98
        flex 0.98
    .pay-func
        margin-top 20px
    .pay-btn-content
        padding 20px 0
        text-align right
    .py15
        padding 15px 0
    .wx-pay-btn-content
        height 80px
        padding 25px 0
    .checked
        color #009ee7
    .list-key > li
        list-style decimal
    .px20
        padding 0 20px
    .py20
        padding 20px 0
    .ext-count
        width 110px
        display inline-block
        border 1px solid #E3E3E3
        height 35px
        line-height 35px
        text-align center
    .min
        border 1px solid transparent
        display inline-block
        height 35px
        width 35px
        line-height 35px
        text-align center
        font-size 20px
        font-weight 700
        color #fff
        background-color #e3e3e3
        cursor pointer
    .plus
        border 1px solid transparent
        display inline-block
        height 35px
        width 35px
        line-height 35px
        text-align center
        font-size 20px
        font-weight 700
        color #fff
        background-color #e3e3e3
        cursor pointer
    .contact-header
        font-size 17px
        padding 15px 25px
    .contact-body
        padding 0 20px
    .text-primary
        color #009ee7 !important
    .flex
        display flex
        align-items center
    .account-balance
        margin-left 10px

</style>
<style>
    .w750 > .modal-dialog > .modal-content {
        width: 750px;
    }
    .integer {
        font-size: 20px;
        color: #ffa700;
    }
    .decimal {
        font-size: 14px;
        color: #ffa700;
    }

</style>
<template>
    <div>
        <div class="mt10 inline-block" v-if="user.isCompanyAdmin && isCompanyAdminView">
            <div class="inline-block pr avator-wrapper">
                <avator :img="user.imgUrl"></avator>
            </div>
            <span class="ml5 acct-name" v-text="user.employerName | cut 10"></span>
            <a class="btn btn-danger btn-sm ml10 btn-admin-logout" @click="logout()">安全退出</a>
        </div>
        <div v-if="isShowType&&!env.isCompanyDomain" class="enter-group">
            <a class="btn btn-sm btn-primary mr10" @click="enterApp"><i class="fa fa-dashboard"></i> 进入应用</a>
            <a class="btn btn-sm btn-danger" href="/e"><i class="fa fa-pencil"></i> 考试入口</a>
        </div>
        <div class="btn-group acct"
             @mouseenter="showCorner=true"
             @mouseleave="showCorner=false"
             v-if="(env.isCompanyDomain&&!isCompanyAdminView)||(!env.isCompanyDomain&&!isShowType)">
            <a class="nav-ldown-topdown-toggle">
                <div class="inline-block pr avator-wrapper">
                    <avator :img="user.imgUrl"></avator>
                </div>
                <span class="ml5 acct-name">
                    {{user.employerName | cut 10}}
                    <span class="caret"></span>
                </span>
            </a>
            <!-- 非企业版, 老师/考官, 非 VIP, 那就充起来吧~  -->
            <a class="btn btn-primary btn-sm btn-upgrade"
               v-if="!env.isCompanyDomain && user.isExaminer && !user.isVip"
               href="/order#/vip" target="_blank"
            >
                升级VIP
            </a>

            <div class="acct-center" v-show="showCorner" transition="menu">
                <div class="center-top flex" v-if="!user.isExaminee">
                    <div class="inline-block pr avator-wrapper vm">
                        <avator :size="50" :img="user.imgUrl"></avator>
                    </div>
                    <div class="acct-info inline-block vm ml5">
                        <div class="acct-item">
                            <span class="acct-name text-ellipsis">
                                {{user.employerName | cut 10}}
                            </span>
                            <span class="acct-type type-vip" v-if="user.isVip">VIP</span>
                            <span class="acct-type type-free" v-if="!user.isVip&&!env.isCompanyDomain">免费</span>
                        </div>
                        <div class="acct-item">
                            <span class="acct-date" v-if="user.isVip && !hasTests">
                                {{expDate | formatTime}} 到期<a href="/order#/vip" target="_blank">立即续费</a>
                            </span>
                            <span v-if="user.isVip && hasTests" class="acct-date">所购考次消费完，VIP身份自动终止</span>
                            <span class="acct-date" v-if="!user.isVip&&!env.isCompanyDomain">
<!--                                <a href="/order#/vip" target="_blank">购买VIP享特权</a>-->
                                <a href="/order#/invioce/applyInvioce" target="_blank">发票申请</a>
                            </span>
                        </div>
                    </div>
                </div>
<!--                <div class="center-middle" v-if="user.isExaminer && !env.isCompanyDomain">-->
<!--                    <button class="btn invite-btn" @click="updateCompany" v-if="user.isVip">-->
<!--                        升级企业版-->
<!--                    </button>-->
<!--                    <div class="btn-area-new" v-else>-->
<!--                        <button class="btn btn-update-company" @click="updateCompany">升级企业版</button>-->
<!--                        <button class="btn btn-update-vip" @click="updateVip">升级VIP</button>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="center-middle" v-if="!user.isExaminee">
                    <div class="middle-item" :class="{'w60': !hasTests, 'w45': hasTests}">
                        <div>
                            <span>当前在线答题 </span>
                            <a class="online-refresh" @click="getStateInfo" :disabled="loading">
                                <i v-if="!loading" class="fa fa-refresh"></i>
                                <i v-else="!loading" class="fa fa-spinner fa-spin"></i>
                            </a>
                            <span class="pointer text-primary" v-if="user.isVip && !hasTests" @click="ext">增购</span>
                        </div>
                        <div>
                            <span v-tooltip :title=isDanger?'在线答题人数已接近上限，为了不影响考试请开通vip或企业版':'' class="middle-count"
                                  :class="{'loading':loading,'danger-count':isDanger}">{{!user.isVip&&!env.isCompanyDomain?resourceUsage:onGoings}}</span>
                            人 / <span
                                v-if="!env.isCompanyDomain && tests!== 0 && !hasTests">上限 {{tests}}</span>
                            {{!env.isCompanyDomain && tests!==0 && testTotal < 1?'人':''}}
                            <span v-else class="text-mint">不限</span>
                        </div>
                    </div>
                    <div class="middle-item" :class="{'w40': !hasTests, 'w55': hasTests}">
                        <div>
                            <p class="tr">{{hasTests ? '剩余考次' : '今日累计'}}</p>
                        </div>
                        <div class="tr">
                            <span v-if="!hasTests" class="middle-count">{{todayReports}}</span> <span v-if="hasTests" class="middle-count">{{testUsed}}</span><span v-if="hasTests">次</span><span class="text-mint" v-if="hasTests">/{{testTotal}}</span>次 <a class="text-primary" v-if="hasTests" @click="contactUs = true">增购</a>
                        </div>
                    </div>
                </div>
                <div class="center-bottom">
                    <div class="bottom-box">
                        <div class="box-item">
                            <a class="btn btn-box bg-white primary-text-color" href="/settings/basic-info">
                                <i class="moon moon-cog"></i>
                            </a>
                            <p>我的设置</p>
                        </div>
                        <div class="box-item">
                            <a class="btn btn-box bg-white primary-text-color" href="/account">
                                <i class="moon moon-user"></i>
                            </a>
                            <p>我的账户</p>
                        </div>
                        <div class="box-item">
                            <a class="btn btn-box bg-white primary-text-color" href="/order">
                                <i class="moon moon-balance"></i>
                            </a>
                            <p>交易记录</p>
                        </div>
                        <div class="box-item">
                            <a class="btn btn-box bg-pink" href="e">
                                <i class="moon moon-entry"></i>
                            </a>
                            <p>考试入口</p>
                        </div>
                    </div>
                </div>
                <div class="center-footer">
<!--                    <a class="btn btn-link" v-if="!env.isCompanyDomain || (env.isCompanyDomain && enableSwitchRole)"-->
<!--                       @click="switchRole"><i class="fa fa-exchange"></i> 切换角色</a>-->
                    <a class="btn btn-link btn-logout" @click="logout"><i class="fa fa-sign-out"></i> 退出</a>
                </div>
            </div>
        </div>
        <modal :visible.sync="visible" title="邀请人情况" :class="{'w11': invited.length>0 || employerInvited}">
            <div slot="header" class="invite-header">
                <i class="fa fa-times" @click="hideModal"></i>
                <img :src="banner" style="width:100%" @click="guider">
            </div>
            <div style="display:flex;justify-content:space-around">
                <div class="py3 px35 mt30 fl3">
                    <div class="invite-info">
                        <img :src="avator" class="avator"/>
                        <div class="pl10">
                            <div class="text-normal">{{user.employerName}}</div>
                        </div>
                    </div>
                    <div class="invite-times">
                        <div class="fl5 tl">
                            <div class="text-grey">累计考次</div>
                            <div class="num">{{totalReports}}</div>
                        </div>
                        <div class="fl5 tr">
                            <div class="text-grey">邀请好友人数</div>
                            <div class="num">{{invited.length}}</div>
                        </div>
                    </div>
                    <div class="invited-code"><span>{{user.inviteCode}}</span></div>
                    <div class="mt10 flex">
                        <share :content="shareConfig"></share>
                    </div>
                </div>
                <div class="p10 px35 blb mt30 fl1" v-if="invited.length>0 || employerInvited">
                    <label class="p10" style="color:#775a2d;background-color:#fdf8ef;font-size:10pt;font-weight:200">注：邀请人与被邀请人都成为
                        #活跃用户#（累计考试次数 500 次）双方即可同时获得一个月VIP使用权</label>
                    <ul>
                        <li class="invite-list list-header">
                            <div class="invite-name fl25">昵称</div>
                            <div class="test-times fl25">状态</div>
                            <div class="invite-account fl25">累计考次</div>
                            <div class="fl25">是否获赠VIP</div>
                            <div class="fl25">是否领取VIP</div>
                        </li>
                        <li class="invite-list" v-if="employerInvited">
                            <div class="invite-name fl25">{{employerInvited.employerInfo.name}}</div>
                            <div class="test-times fl25">邀请人</div>
                            <div class="invite-account fl25">{{employerInvited.reports}}</div>
                            <div class="fl25">{{giftState(employerInvited.giftState)}}</div>
                            <div class="fl25">{{employerInvited.receiveState === 1 ?'已领取' : '未领取'}}</div>
                        </li>
                        <li v-for="i in invited" class="invite-list">
                            <div class="invite-name fl25">{{i.employerInfo.name}}</div>
                            <div class="test-times fl25">被邀请人</div>
                            <div class="invite-account fl25">{{i.reports}}</div>
                            <div class="fl25">{{giftState(i.giftState)}}</div>
                            <div class="fl25">{{i.receiveState === 1 ?'已领取' : '未领取'}}</div>
                        </li>
                    </ul>
                </div>
            </div>

            <div slot="footer" style="height:50px"></div>
        </modal>
        <modal :visible.sync="buyExt" class="w750">
            <div slot="header" class="ext-header">
                <div>增购并发数</div>
            </div>
            <div class="flex-content">
                <div class="fl4">
                    <div class="pb10"><span class="ext-sub-title">当前套餐：</span> {{vipInfo.saleName}}（{{vipInfo.tests}}并发数）</div>
                    <div class="pb10"><span class="ext-sub-title">有效期至：</span> {{vipInfo.expDate | formatTime}}</div>
                    <div class="ext-sub-title pb10 mt20">增购的并发数</div>
                    <div class="pb10 flex">
                        <span class="min" @click="minExt">-</span>
                        <div class="ext-count">{{count}}</div>
                        <span class="plus" @click="plusExt">+</span>
                    </div>
                    <div>
                        <span class="ext-sub-title">您需要支付:</span>
                        <span style="font-size: 18px;color: red;">{{realPrice.toFixed(0)/100}}</span>元
                    </div>
                    <div style="margin-top: 70px;">
                        <a @click="showRule">增购规则及计价说明</a>
                    </div>
                </div>
                <div class="fl6">
                    <div class="ext-sub-title">请选择支付方式：</div>
                    <div class="pay-func">
                        <div class="flex p10 weixin-pay pointer" :class="{'active': payFunc === 'weixin'}" @click="payFunc = 'weixin'">
                            <i class="fa mr20 fa-weixin"></i>
                            <div class="fl98">微信</div>
                            <i class="fa fa-check pull-right" v-if="payFunc === 'weixin'"></i>
                        </div>
                        <div class="flex p10 ali-pay pointer" :class="{'active': payFunc === 'alipay'}" @click="payFunc = 'alipay'">
                            <i class="fa mr20 moon moon-alipay"></i>
                            <div class="fl98">支付宝</div>
                            <i class="fa fa-check pull-right" v-if="payFunc === 'alipay'"></i>
                        </div>
                    </div>
                    <div class="mt20"><i class="fa fa-square-o pointer checked ft20 pr5" :class="{'fa-check-square': readed}" @click="readed = !readed"></i>我已阅读
                        <a @click="showTreaty">《购买协议》</a>
                    </div>
                    <div class="pay-btn-content">
                        <button class="btn btn-primary" @click="goPay" :disabled="!readed">支付</button>
                    </div>
                </div>
            </div>
            <div slot="footer" style="height: 20px;"></div>
        </modal>
        <modal :visible.sync="dealShow" :no-footer="true">
            <div v-if="treaty">
                <h4 class="modal-title tc text-primary py15" slot="header">购买协议</h4>
                <div class="px20">
                    在此特别提醒用户认真阅读本《购买协议》。
                    <ol class="list-key">
                        <li>您在勾选本协议文本并进行购买时便说明您已经认真阅读本文本内容并认可本文本规定，若您对本文本有任何异议，请立即停止购买本平台用户发布的题库，以免双方产生纠纷，谢谢！</li>
                        <li>百一将根据法律法规、规章制度、相关政策及本站的规定，对用户发布到商店的资源进行审查，对经初步审查合格的题库，将予以审查通过，允许在网站上展示分享。</li>
                        <li>百一测评是网络服务提供商，网站的商店内的资源都是本站的用户上传，与本站的下载用户自行通过网站交易达成的。本站的下载用户知道且认可本站只提供服务，不在交易过程中承担任何角色。</li>
                        <li>考虑到电子商品的特殊性，用户购买了商品后一般不允许退货。如果有争议，可以走线下友好协商解决。</li>
                        <li>用户可以自行上传题库和试卷，发布到商店被下载后将获得相应分值的积分，所得积分可用来购买商店内的资源及在购买vip会员时抵扣一定数额的现金。</li>
                        <li>商店内资源的积分均由发布者设定。用户在本站商店内购买的资源不可再用于发布到商店出售。</li>
                    </ol>
                    <div class="tc py20" slot="footer">
                        <button type="button" class="btn btn-default" @click="hideDeal">关闭</button>
                    </div>
                </div>
            </div>
            <div v-if="rule">
                <h4 class="modal-title tc text-primary py15" slot="header">增购规则及计价说明：</h4>
                <div class="px20">
                    <ol class="list-key">
                        <li>增购的并发数不享受折扣优惠</li>
                        <li>增购的补充包有效期至当前VIP套餐的结束日期</li>
                        <li>增购的并发数计价规则：原价VIP套餐选择的有效期内的升级单价 X 叠加的并发人数 X （剩余可生效的天数 / 总有效天数）</li>
                    </ol>
                    <div class="tc py20" slot="footer">
                        <button type="button" class="btn btn-default" @click="hideDeal">关闭</button>
                    </div>
                </div>
            </div>
        </modal>
        <modal :visible.sync="showQrCode" width="300" :no-footer="true">
            <div>
                <div slot="header">
                    <h4 class="modal-title tc text-primary py15">使用微信扫一扫进行支付</h4>
                </div>
                <div class="center-block" style="width: 200px; height: 200px; text-align: center;" v-el:qr></div>
                <div slot="footer" class="tc wx-pay-btn-content">
                    <button class="btn btn-default" @click="payFail">支付失败</button>
                    <button class="btn btn-primary ml20" @click="paySuccess">支付成功</button>
                </div>
            </div>

        </modal>
        <modal :visible.sync="contactUs" width="400" :no-footer="true">
            <div slot="header" class="contact-header">提示</div>
            <div class="contact-body">
                <div class="py10">
                    {{testTotal > 0 ? '增购考次' : '增购并发'}}请联系百一销售顾问：
                </div>
                <div>电话：010-82166778</div>
                <div>QQ：2019598537</div>
                <div>QQ：2905483660</div>
            </div>
            <div class="tc py20">
                <button class="btn btn-default" @click="contactUs = false">确定</button>
            </div>
        </modal>

        <modal :visible.sync="aliPayModal" width="500" :no-footer="true">
            <div slot="header" class="contact-header">正在支付</div>
            <div class="contact-body">
                请在新打开的页面中完成支付。<span class="text-bittersweet">支付完成前，请不要关闭此窗口。</span>支付完成后请根据您的支付情况点击下面的按钮
            </div>
            <div class="tr py20">
                <button class="btn btn-default" @click="aliPayModal = false">支付失败</button>
                <button class="btn btn-primary" @click="paySuccess">支付成功</button>
            </div>
        </modal>
    </div>
</template>

<script lang="babel">
    /**
     * Footer
     */
    /* eslint-disabled */
    import Avator from './avator.vue'
    // 不要这么用...webpack 将会打包整个 bootsets/components 目录.......
    //    import { confirm, msg } from 'bootsets/components'
    import confirm from 'bootsets/components/confirm'
    import msg from 'bootsets/components/msg'
    import {accountModel} from 'bootsets/models'
    import {cut} from 'bootsets/utils'
    import {tooltip} from 'bootsets/directives'
    import moment from 'moment'
    import {user, company, env, params, request} from 'bootsets/runtime'
    import {CompanyPerm, EmployerType, EmployerType_desc, SetsConst, GiftState, PurchaseType, VipMode} from 'core/constant'
    import {isAdminView, switch2NormalView, getCurrentNavs, getFirstPage} from './navbar-util'
    import 'assets/fonts/moon/moon.css'
    import {modal} from '../../bootsets/components'
    import share from './share.vue'
    export default{
        components: {Avator, modal, share},
        directives: {tooltip},
        props: {},
        data() {
            return {
                currentPageType: +params.pageType || +request.pageType || '',
                showCorner: false,
                env,
                user,
                // 当前视图是否为管理员视图
                isCompanyAdminView: isAdminView(),
                EmployerType,
                SetsConst,
                onGoings: '',
                resourceUsage: '',
                todayReports: '',
                loading: false,
                expDate: '',
                invited: [],
                employerInvited: null,
                visible: false,
                shareConfig: {
                    title: '百一测评白送VIP啦！现在注册，咱俩都能免费获得VIP。名额有限，快点行动吧！',
                    desc: '百一测评白送VIP啦！现在注册，咱俩都能免费获得VIP。名额有限，快点行动吧！',
                    url: `${env.root}act/open/home?inviteCode=${user.inviteCode}`,
                    appKey: '894937143',
                },
                totalReports: '',
                tests: 0,
                buyExt: false,
                vipInfo: {},
                count: 10,
                payFunc: null,
                showQrCode: false,
                qrCode: null,
                readed: true,
                dealShow: false,
                treaty: false,
                rule: false,
                maxExt: 0,
                contactUs: false,
                testTotal: 0,
                testUsed: 0,
                canExt: true,
                vipMode: 40,
                balance: 0,
                aliPayModal: false
            }
        },
        events: {
            ['show-invitation']() {
                this.visible = true
            }
        },
        filters: {
            cut,
            formatTime(t) {
                return moment(t).format("YYYY-MM-DD")
            }
        },
        watch: {
            buyExt() {
                if (this.buyExt === false) {
                    this.count = 10
                }
            }
        },
        computed: {
            // 允许切换角色
            enableSwitchRole() {
                //return company.perm & CompanyPerm.ALLOW_SWITCH
                return user.registerType === EmployerType.EXAMINER ||
                        user.isCompanyAdmin
            },
            getCurrentDate () {
                return new Date(moment().format("YYYY-MM-DD")).getTime()
            },
            isDanger(){
                return !user.isVip && !env.isCompanyDomain && this.resourceUsage >= this.SetsConst.MAX_TESTS_CONCURRENCY * 0.9
            },
            banner() {
                return this.invited.length > 0 || this.employerInvited ? 'app/scaffold/invite-resource/invite-banner.png' : 'app/scaffold/invite-resource/min-invite-banner.png'
            },
            avator() {
                return user.imgUrl || '/assets/img/report/portrait_default.png'
            },
            isShowType(){
                return this.currentPageType === 1 ||
                        this.currentPageType === 2 ||
                        this.currentPageType === 3 ||
                        showBlackBar
            },
            realPrice() {
                return this.vipInfo.upgradePrice * this.count * ((((new Date(moment(this.vipInfo.expDate).format("YYYY-MM-DD")).getTime() - new Date(moment().format("YYYY-MM-DD")).getTime())/86400000) / ((new Date(moment(this.vipInfo.expDate).format('YYYY-MM-DD')).getTime() - new Date(moment(this.vipInfo.effDate).format('YYYY-MM-DD')).getTime())/86400000)))
            },
            hasTests() {
                return VipMode.VIP_TEST_AMOUNT === this.vipMode
            },
            getAccountBalance() {
                return `<span class="integer">${(this.balance / 100 + ' ').split('.')[0]}</span><span class="decimal">.${(this.balance / 100 + ' ').split('.')[1] || '00'}</span>`
            }
        },
        methods: {
            logout() {
                accountModel.logout().then(() => {
                    window.location.href = '/home'
                })
            },
            updateVip() {
                window.location.href = '/order#/vip'
            },
            updateCompany() {
                window.location.href = '/company/open/apply'
            },
            enterApp() {
                let href = getFirstPage(window.SETS.user.employerType)
                window.location = href
            },
            showRule() {
                this.dealShow = !this.dealShow
                this.rule = true
                this.treaty = false
            },
            showTreaty () {
                this.dealShow = !this.dealShow
                this.treaty = true
                this.rule = false
            },
            hideDeal () {
                this.dealShow = false
                this.treaty = false
                this.rule = false
            },
            switchRole() {
                const switchFromDesc = EmployerType_desc[+user.employerType]
                const switchToType = user.isExaminee ? EmployerType.EXAMINER : EmployerType.EXAMINEE
                const switchToDesc = EmployerType_desc[switchToType]
                confirm.warning({
                    title: '切换角色',
                    content: `当前角色为【 ${switchFromDesc} 】，确定要切换至【 ${switchToDesc} 】吗？`,
                    okText: '切换',
                    onOk() {
                        accountModel.switchRole(switchToType).then(
                                () => {
                                    let toHref = getCurrentNavs(switchToType)[1].href;
                                    window.location.href = window.SETS.env.isCompanyDomain ? toHref : switchToType === EmployerType.EXAMINEE ? 'group' : 'paper'
                                },
                                (err) => {
                                    msg.danger(err)
                                    console.log(getCurrentNavs(switchToType))
                                }
                        )
                    }
                })
            },
            /**
             * 切换视图为
             */
            switchView(role) {
                // 将当前视图切换为普通视图
                switch2NormalView()
                // 获取切换视图后的导航
                const nav = getCurrentNavs()[0]
                window.location.href = nav ? nav.href : '/'
            },
            getStateInfo(){
                if (this.loading) {
                    return;
                }
                this.loading = true
                accountModel.getStatInfo().then(
                        (data) => {
                            this.onGoings = data.onGoings
                            this.resourceUsage = data.reosurceUsage
                            this.todayReports = data.todayReports
                            this.loading = false
                            this.invited = data.inviteEmployers || []
                            this.employerInvited = data.employerInvited
                            this.totalReports = data.totalReports
                            window.SETS.user.onGoings = data.onGoings
                        },
                        (err)=> {
                            this.loading = false
                        }
                )
            },
            getAccountInfo(){
                accountModel.getWealth().then((data) => {
                    this.expDate = data.expDate
                    this.tests = data.tests
                    this.testTotal = data.testTotal
                    this.testUsed = data.testUsed
                    this.vipMode = data.vipMode
                    this.balance = data.accountBalance
                },(err) =>msg.danger(err))
            },
            showInvite() {
                this.visible = true
            },
            hideModal() {
                this.visible = false
            },
            giftState(state) {
                return state === GiftState.NOT_PRESENTED ? '未获赠' : '已获赠'
            },
            guider() {
                location.href = '/act/open/home'
            },
            ext() {
                console.log(this.maxExt)
                if (this.canExt && this.maxExt > 0 ) {
                    this.buyExt = true
                } else {
                    this.contactUs = true
                }
            },
            hideExtModal() {
                this.buyExt = false
            },
            minExt (){
                if ( 10 < this.count && this.maxExt - this.count >= 0) {
                    this.count -= 10
                }
            },
            plusExt () {
                if (10 <= this.count && this.maxExt - this.count > 0) {
                    this.count += 10
                } else {
                    this.contactUs = true
                }
            },
            goPay () {
                let relPrice = this.vipInfo.upgradePrice * this.count * ((((new Date(moment(this.vipInfo.expDate).format("YYYY-MM-DD")).getTime() - new Date(moment().format("YYYY-MM-DD")).getTime())/86400000) / ((new Date(moment(this.vipInfo.expDate).format('YYYY-MM-DD')).getTime() - new Date(moment(this.vipInfo.effDate).format('YYYY-MM-DD')).getTime())/86400000)))
                console.log(((((new Date(moment(this.vipInfo.expDate).format("YYYY-MM-DD")).getTime() - new Date(moment().format("YYYY-MM-DD")).getTime())/86400000) / ((new Date(moment(this.vipInfo.expDate).format('YYYY-MM-DD')).getTime() - new Date(moment(this.vipInfo.effDate).format('YYYY-MM-DD')).getTime())/86400000))))
                switch (this.payFunc) {
                case 'weixin':
                    accountModel.wxPayExt({
                        purchaseType: PurchaseType.EMPLOYER_VIP_MORE,
                        details: [{
                            resId: this.vipInfo.resId,
                            resType: this.vipInfo.resType,
                            price: relPrice.toFixed(0),
                            purchaseNum: this.count
                        }]
                    }).then((result) => {
                        const self = this
                        this.buyExt = false
                        this.showQrCode = true
                        if (!this.qrCode) {
                            this.qrCode = new QRCode(self.$els.qr, {
                                text: result.codeUrl,
                                width: 200,
                                height: 200,
                                colorDark: "#000000",
                                colorLight: "#ffffff",
                                correctLevel: QRCode.CorrectLevel.H
                            })
                        } else {
                            this.qrCode.makeCode(result.codeUrl)
                        }

                        console.log(this.qrCode)
                    })
                    break
                case 'alipay':
                    // 支付宝支付
                    window.open(SETS_ROOT + this.addUrlParams('goAliPayVip', {
                                purchaseType: PurchaseType.EMPLOYER_VIP_MORE,
                                details: encodeURIComponent(JSON.stringify([{
                                    resId: this.vipInfo.resId,
                                    resType: this.vipInfo.resType,
                                    price: relPrice.toFixed(0),
                                    purchaseNum: this.count
                                }]))
                            }))
                    this.buyExt = false
                    this.aliPayModal = true
                    break
                case 'account':
                    accountModel.accountPay({
                        purchaseType: PurchaseType.EMPLOYER_VIP_MORE,
                        details: [{
                            resId: this.vipInfo.resId,
                            resType: this.vipInfo.resType,
                            price: relPrice.toFixed(0),
                            purchaseNum: this.count
                        }]
                    }).then(() => {
                        window.location.replace('/account')
                    }, () => {
                        this.payFailModal = true
                    })
                }
            },
            paySuccess () {
                window.location.replace('/account')
            },
            payFail () {
                this.showQrCode = false
            },
            addUrlParams (url, params, encode, ignoreNullValue) {
                let hasParams
                // eslint-disable-next-line
                let key_name
                let paramList = []
                let aIndex = url.indexOf('#')
                let qIndex = url.indexOf('?')
                let endIndex = url.length
                let anchorString = ''
                let paramString
                let urlString
                // 当问号在#号之后时?之后的不是params
                if (qIndex > aIndex && aIndex > 0) {
                    qIndex = -1
                }
                for (key_name in params) {
                    if (params.hasOwnProperty(key_name)) {
                        hasParams = true;
                        break;
                    }
                }
                if (!hasParams) {
                    return url;
                }
                if (aIndex != -1) {
                    anchorString = url.slice(aIndex, endIndex);
                    endIndex = aIndex;
                }
                if (ignoreNullValue) {
                    for (key_name in params) {
                        if (params.hasOwnProperty(key_name) && (params[ key_name ] == null || params[ key_name ] == undefined || params[ key_name ] == '')) {
                            delete params[ key_name ];
                        }
                    }
                }
                if (qIndex != -1) {
                    paramString = url.slice(qIndex + 1, endIndex);
                    endIndex = qIndex;
                    var paramArray = paramString.split('&');
                    for (var i in paramArray) {
                        if (paramArray[ i ]) {
                            var eqIndex = paramArray[ i ].indexOf('=') != -1 ? paramArray[ i ].indexOf('=') : paramArray[ i ].length;
                            var paramItem = [ paramArray[ i ].slice(0, eqIndex), paramArray[ i ].slice(eqIndex + 1, paramArray[ i ].length) ]
                            if (params.hasOwnProperty(paramItem[ 0 ])) {
                                paramItem[ 1 ] = encode ? encodeURIComponent(params[ paramItem[ 0 ] ]) : params[ paramItem[ 0 ] ];
                                delete params[ paramItem[ 0 ] ];
                            }
                            paramList.push({ key: paramItem[ 0 ], value: paramItem[ 1 ] })
                        }
                    }
                }

                for (key_name in params) {
                    if (params.hasOwnProperty(key_name)) {
                        paramList.push({
                            key: key_name,
                            value: encode ? encodeURIComponent(params[ key_name ]) : params[ key_name ]
                        })
                    }
                }
                paramString = '';
                for (var i in paramList) {
                    var and = i > 0 ? '&' : '';
                    paramString += and + paramList[ i ].key + '=' + paramList[ i ].value;
                }
                urlString = url.slice(0, endIndex);
                return urlString + '?' + paramString + anchorString;
            }
        },
        ready(){
            this.getStateInfo()
            this.getAccountInfo()
            if (params.invited === '1') {
                this.visible = true
            }
            if (user.isVip) {
                accountModel.getCurrentVipInfo().then((result) => {
                    this.vipInfo = result
                    this.maxExt = 500 - result.tests
                    window.SETS.vipInfo = result
                }, (err) => {
                    if(err) {
                        this.canExt = false
                    }
                })
            }
        }
    }
</script>
<style lang="stylus" scoped>
    $navHeight = 54px
    $padding = 20px
    $color = #444444
    $lightColor = #777777
    $highlightColor = #fdc02f
    $activeColor = #009ee7
    $borderColor = lighten($lightColor, 80%)
    $containerWidth = 270px
    $boxWidth = 50px
    $boxMarginLeft = floor($containerWidth - 2 * $padding - $boxWidth * 4) / 3
    .w60
        width 60%
    .w40
        width 40%
    .w45
        width 45%
    .w55
        width 55%
    .acct
        min-width 120px
        padding 0 15px
        height $navHeight
        line-height $navHeight
        a.nav-ldown-topdown-toggle
            color #444
        &.btn-group
            > a.btn.btn-upgrade
                float right
                margin 12px 0 0 10px
                border-radius 2px
                color #009ee7
                border 1px solid transparent
                background-color transparent
                font-size 14px
                &:hover
                    background-color #009ee7
                    color #ffffff
        &:hover
            a.nav-ldown-topdown-toggle
                color $lightColor

    .acct-center
        cursor: default
        -webkit-font-smoothing antialiased
        -moz-osx-font-smoothing grayscale
        display block
        line-height 1.4
        width: $containerWidth
        position: absolute
        top $navHeight
        border-radius 2px
        overflow hidden
        right: 0
        background #fff
        color $color
        box-shadow 0 6px 12px 3px rgba(0, 0, 0, .175)
        overflow visible
        .center-top
            padding $padding
            vertical-align middle
            .acct-name
                vertical-align text-bottom
                max-width 115px
                display inline-block
            .acct-type
                padding 2px 10px
                border-radius 10px
                color #FFF
                font-size .8em
                line-height 2
            .type-vip
                background-color $highlightColor
            .type-free
                background-color #c3c1c1
            .acct-date
                font-size .9em
                color $lightColor
                a
                    margin-left 1em
                    color $activeColor
                    &:hover
                        color lighten($activeColor, 20%)
        .center-middle
            padding 0 $padding
            color $lightColor
            &:after
                content: ''
                display table
                clear both
            .middle-item
                float left
                font-size 0.9em
                box-sizing border-box
                &:first-child
                    border-right 1px solid $borderColor
                &:last-child
                    padding-left $padding
                a
                    color $lightColor
                    &:hover
                        color $activeColor
                .middle-count
                    font-size 1.6em
                    font-weight bold
                    transition color .15s ease
                    &.danger-count
                        color #FC5050
                    &.loading
                        color lighten($lightColor, 10%)
        .center-bottom
            margin-top 10px
            padding 10px $padding 0
            .bottom-box
                border-top 1px solid $borderColor
                padding $padding 0
                font-size .9em
                &:after
                    content: ''
                    display table
                    clear both
                .box-item
                    display inline-block
                    float left
                    margin-left $boxMarginLeft
                    width $boxWidth
                    &:first-child
                        margin-left 0
                    .btn-box
                        display block
                        height $boxWidth
                        background-color: #29cdb5;
                        border-color: #29cdb5;
                        line-height $boxWidth
                        text-align center
                        font-size 1.8em
                        padding 0
                        color #FFF
                        &.btn-entrance
                            background-color: #FC5050;
                            border-color: #FC5050;
                            &:hover
                                background-color: lighten(@background-color, 20%)
                        &:hover
                            background-color: #f2f5f6
                    p
                        white-space nowrap
                        margin-top ($padding/ 2)
        .center-footer
            overflow hidden
            background-color #333
            a
                border none
                color #FFF
                font-size .9em
                padding 10px $padding
                color #999
                float left
                width 50%
                text-align left
                &:hover
                    color #FFf
                &.btn-logout
                    float right
                    text-align right

    .invite-btn
        width 100%
        background-color #009ee7
        margin-bottom 15px
        margin-top -5px
        border none

    .invite-header
        background-color #cef4ff
        border-top-left-radius 4px
        border-top-right-radius 4px
        position relative
        .fa
            color #fff
            right 14px
            top 10px
            position absolute
            font-size 15pt
            cursor pointer

    .invited-code
        background url("./invite-resource/invite-code.png")
        height 112px
        background-size 100%
        position relative
        ::selection
            background: #D7D4F0;
            color: #fff;
        > span
            position absolute
            top 30px
            left 50px
            font-size 25pt
            color #fff

    .fl1
        flex 1

    .fl25
        flex .25 !important

    .fl3
        width 350px

    .fl5
        flex .5
        .num
            font-size 20pt

    .avator
        width 50px
        height 50px
        border-radius 50%
        border 3px solid #ffa800

    .invite-info
        display flex

    .py3
        padding 30px 0

    .px35
        padding 0 35px

    .text-grey
        color #777777

    .text-normal
        font-size 12pt
        line-height 50px

    .pt5
        padding-top 5px

    .invite-times
        display flex
        padding 15px 0

    .blb
        border-left 1px solid #e3e3e3

    .invite-now
        width 100%
        height 40px
        border-radius 8px
        background-color #ffc107
        box-shadow none
        border none
        color #fff

    .list-header
        border-bottom 1px solid #009ee7 !important

    .btn-area-new
        display flex
        padding-bottom 15px

    .btn-update-company
        background-color #009ee7
        color #fff
        width 50%
        border-radius 3px
        border 1px solid transparent
    .btn-update-vip
        margin-left 10px !important
        background-color #fda32a
        color #fff
        width 50%
        border-radius 3px
        border 1px solid transparent

</style>
<style lang="stylus">
    .w11 > .modal-dialog
        width 1100px
</style>



// WEBPACK FOOTER //
// login-corner.vue?14a13474